import c from '../../../util/const'
import React, {Component} from 'react';
import {connect} from "react-redux";

import PropTypes from 'prop-types';
import workspaceActions from "../../../actions/workspace-actions";
import modalActions from "../../../actions/modal-actions";
import filters from "../../../helpers/filters";
import Button from "../elements/Button";
import sapi from "../../../util/sapi";
import Image from "../elements/Image";
import Promise from "bluebird";
import PreviewWindow from "../../modals/PreviewWindow";
import downloadActions from "../../../actions/download-actions";
import {withVFTranslation} from "../../../util/withVFTranslation";

class SvgPreview extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: null
    }
  }

  componentDidMount() {
    if(this.props.onRef){
      this.props.onRef(this)
    }

    let {forum_id, host_uid, doc_id} = this.props;

    this.setState({loading: true})
    sapi.Docs.view(forum_id, host_uid, doc_id, false)
      .then((res) => {
        this.setState({
          data: res
        })
      })
      .finally(() => {
        this.setState({loading: false})
      })
  }

  componentWillUnmount() {
    if(this.props.onRef){
      this.props.onRef(undefined);
    }
  }

  closeModal() {
    this.props.close();
  }

  onEscapeKey(){
    this.closeModal(false);
  }

  setWindowMode(mode) {
    let {setWindowMode} = this.props;

    setWindowMode(mode);
  }

  getDownloadHeaders() {
    let {doc_id, forum_id, host_uid} = this.props;

    let params = {
      doc_id,
      forum_id
    }

    if (host_uid) {
      params.host_uid = host_uid;
    }

    params[c.api.X_TOKEN] = sapi.getToken();

    return params;
  }

  downloadDoc() {
    this.props.doDownload(this.getDownloadHeaders(), sapi.Docs.url('download'))
  }

  render() {
    let {doc_info, t} = this.props;
    let {data} = this.state;

    return (
      <div className="modal-content">
        <div className="modal-header draggable-header">
          <h5 className="modal-title">{doc_info.label}</h5>
          <button type="button" className="close" onClick={this.closeModal.bind(this)} aria-label={t("Close")}>
            <i className="icon ion-ios-close-empty" />
          </button>
        </div>
        <div className="modal-body svg-wrapper"
             style={{width: '100%'}}
             dangerouslySetInnerHTML={{__html: data}}>
        </div>
        <div className="modal-footer">
          <Button className={'btn btn-primary'} onClick={this.downloadDoc.bind(this)}>{t("Download")}</Button>
          <Button className={'btn btn-primary'} onClick={this.closeModal.bind(this)}>{t("OK")}</Button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    doDownload:(headers, url) => dispatch(downloadActions.doDownload(headers, url))
  };
};

SvgPreview.propTypes = {
  close: PropTypes.func.isRequired,
  setWindowMode: PropTypes.func.isRequired,
  doc_info: PropTypes.object.isRequired,
  forum_id: PropTypes.string.isRequired,
  host_uid: PropTypes.string,
  doc_id: PropTypes.string.isRequired,
  onRef : PropTypes.func,
}

export default withVFTranslation()(connect(mapStateToProps, mapDispatchToProps)(SvgPreview));
